import { useQueryParams } from '@shared/utils/hooks/useQueryParams';

const supportedScenarios = ['app', 'default', 'guest-list', 'imagine-your-card', 'invitation', 'registry', 'save-the-date', 'wedding-website'] as const;

type Scenario = (typeof supportedScenarios)[number];

export const useScenario = (): Scenario => {
  const queryParams = useQueryParams();

  return supportedScenarios.includes(queryParams.scenario as Scenario) ? (queryParams.scenario as Scenario) : 'default';
};
